import React, { useState, useEffect } from "react";
import { Row, Col, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";

import {
  setUserPermissionsIsEdit,
  updateUserPermissions,
  updateUserSettings,
} from "../redux/actions";
import { ReactComponent as SaveIcon } from "../../../assets/save-icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/edit-icon.svg";
import SpinnerComponent from "../../../components/spinner";
import PermissionsSection from "./permissionsSection";
import UseSupAdminOrAdminWithUserManagerPermission from "../../../components/useSupAdminOrAdminWithUserManagerPermission";

const GeneralPermissions = ({ isProfileCase, canUpdate }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    popupNotifications: false,
    emailNotifications: false,
  });

  const [upperPermissions, setUpperPermissions] = useState({
    project_setup: {
      add_edit: false,
      view: false,
      export: false,
      delete: false,
    },
    project_weightings: {
      add_edit: false,
      view: false,
      delete: false,
    },
    project_priorities: {
      add_edit: false,
      view: false,
      delete: false,
    },
    navisworks_file_export: {
      export: false,
    },
  });

  const [state, setState] = useState({
    user_manager: { add_edit: false, view: false },
    departments: { add_edit: false, view: false },
    material_templates: { add_edit: false, view: false },
    material_types: { add_edit: false, view: false },
    project_statuses: { add_edit: false, view: false },
    locations: { add_edit: false, view: false },
    supplier: { add_edit: false, view: false },
    commodity: { add_edit: false, view: false },
  });
  let canEditEveryThing = UseSupAdminOrAdminWithUserManagerPermission();

  const {
    currentUserObj,
    popupLoading,
    emailLoading,
    permissionsLoading,
    userPermissionsIsEdit,
  } = useSelector((state) => state.userManagerReducer);

  useEffect(() => {
    if (currentUserObj?.id > 0) {
      const { popupNotifications, emailNotifications } = currentUserObj;
      setData({
        popupNotifications,
        emailNotifications,
      });

      if (currentUserObj?.permissions !== null) {
        const { project_setup, project_weightings, project_priorities, navisworks_file_export, ...rest } = currentUserObj.permissions;

        const newSettingsState = { ...state };
        Object.keys(newSettingsState).forEach((key) => {
          if (rest[key]) {
            newSettingsState[key] = rest[key];
          }
        });
        setState(newSettingsState);
        setUpperPermissions({ 
          ...upperPermissions, 
          project_setup: project_setup || upperPermissions.project_setup,
          project_weightings: project_weightings || upperPermissions.project_weightings,
          project_priorities: project_priorities || upperPermissions.project_priorities,
          navisworks_file_export: navisworks_file_export || upperPermissions.navisworks_file_export
        });
      }
    } else if (currentUserObj.id === 0) {
      // For new users, ensure permissions are initialized with default values
      // Explicitly a new user (id = 0) - set edit mode
      dispatch(setUserPermissionsIsEdit(true));
    }
  }, [currentUserObj, dispatch]);

  const handleSave = () => {
    dispatch(
      updateUserPermissions({
        permissions: { ...upperPermissions, ...state },
        id: currentUserObj?.id,
      })
    );
  };

  const onChangeNotification = (key, checked, loadingObj) => {
    setData({ ...data, [key]: checked });
    const { id } = currentUserObj;
    dispatch(
      updateUserSettings({
        data: { id, [key]: checked },
        loadingObj,
      })
    );
  };

  return (
    <>
      <Row>
        <Col span={24} className="heading-col">
          <Row align="middle" justify="space-between">
            <Col>
              <div>
                <span className="heading-span user-details-heading">General Permissions</span>
              </div>
            </Col>
            {/* {!isProfileCase && canEditEveryThing && ( */}
            <Col>
              {userPermissionsIsEdit ? (
                permissionsLoading ? (
                  <SpinnerComponent fontSize={14} />
                ) : (
                  <SaveIcon className="save-icon" width={16} height={16} onClick={handleSave} />
                )
              ) : (
                canUpdate && (
                  <EditIcon
                    width={16}
                    fill="#f25003"
                    height={16}
                    onClick={() => dispatch(setUserPermissionsIsEdit(true))}
                  />
                )
              )}
            </Col>
            {/* )} */}
          </Row>
        </Col>
        <PermissionsSection
          state={state}
          setState={setState}
          upperPermissions={upperPermissions}
          setUpperPermissions={setUpperPermissions}
          readOnly={userPermissionsIsEdit}
        />

        <Col span={24} className="section-body settings-section">
          <Row
            align="middle"
            justify="space-between"
            className="simple-heading-col"
          >
            {/* <Col md={0} lg={2} xl={1} xxl={1}></Col> */}
            <Col md={23} lg={23} xl={23} xxl={23}>
              <div>
                <span className="heading-span">
                  General Permissions Notifications
                </span>
              </div>
            </Col>
          </Row>
          <Row style={{ paddingLeft: "12px" }}>
            <Col md={0} lg={2} xl={1} xxl={1}></Col>
            {/* <Col md={8} lg={6} xl={4} xxl={4}>
              <div className="heading-text">Browser notifications</div>
              <div className="switch-parent-div">
                <span className={`${!data.popupNotifications && "off"}`}>
                  Off
                </span>{" "}
                <Switch
                  size="small"
                  defaultChecked={true}
                  checked={data.popupNotifications}
                  disabled={(currentUserObj?.id ? false : true) || popupLoading}
                  onChange={(e) =>
                    onChangeNotification("popupNotifications", e, {
                      popupLoading: false,
                    })
                  }
                />{" "}
                <span className={`${data.popupNotifications && "on"}`}>
                  On
                </span>
              </div>
            </Col> */}
            <Col>
              <div className="heading-text">Email notifications</div>
              <div className={"switch-parent-div"}>
                <span className={`${!data.emailNotifications && "off"}`}>
                  Off
                </span>{" "}
                <Switch
                  size="small"
                  defaultChecked={true}
                  disabled={(currentUserObj?.id ? false : true) || emailLoading}
                  checked={data.emailNotifications}
                  onChange={(e) =>
                    onChangeNotification("emailNotifications", e, {
                      emailLoading: false,
                    })
                  }
                />{" "}
                <span className={`${data.emailNotifications && "on"}`}>
                  On
                </span>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
export default GeneralPermissions;
